(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["account"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Loop through all forms containing the address fields
    document.querySelectorAll('form').forEach(function (form) {
      // Handle country select elements within the form
      form.querySelectorAll('select[data-address-country-select]').forEach(function (countrySelect) {
        // Get the default country value from the data-default attribute
        const defaultCountry = countrySelect.getAttribute('data-default');

        if (defaultCountry) {
          // Find the option that matches the data-default either by value or text
          const matchingOption = Array.from(countrySelect.options).find(
            (option) => option.value === defaultCountry || option.text.trim() === defaultCountry,
          );

          if (matchingOption) {
            // Set the selected option
            countrySelect.value = matchingOption.value;

            // Trigger a change event to load provinces if necessary
            const changeEvent = new Event('change');
            countrySelect.dispatchEvent(changeEvent);
          }
        }
      });

      // Handle provinces loading if there's any dynamic province select logic
      form.querySelectorAll('select[name="address[province]"]').forEach(function (provinceSelect) {
        const defaultProvince = provinceSelect.getAttribute('data-default');

        if (defaultProvince) {
          // Find the option that matches the data-default either by value or text
          const matchingOption = Array.from(provinceSelect.options).find(
            (option) => option.value === defaultProvince || option.text.trim() === defaultProvince,
          );

          if (matchingOption) {
            // Set the selected province
            provinceSelect.value = matchingOption.value;
          }
        }
      });

      // Handle default address checkbox
      const defaultAddressCheckbox = form.querySelector('input[name="address[default]"]');
      if (defaultAddressCheckbox) {
        const isDefault = defaultAddressCheckbox.getAttribute('data-default') === 'true';
        defaultAddressCheckbox.checked = isDefault;
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const isEditor = !!(window.Shopify && Shopify.designMode);

    const debounce = (fn, delay = 250) => {
      let timer;
      return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => fn.apply(this, args), delay);
      };
    };

    const getSection = () => document.querySelector('#product-recommendations');

    const fetchRecommendations = async (targetNode) => {
      try {
        if (!targetNode) targetNode = getSection();
        if (!targetNode) return;

        var skeletonEl = targetNode.closest('[id^="shopify-section-"]');
        var skel = skeletonEl ? skeletonEl.querySelector('.pr-skeleton') : null;

        const url = targetNode.dataset.url;
        if (!url) return console.warn('[PR] Missing data-url');

        const res = await fetch(url, { cache: 'no-store' });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const html = await res.text();

        const temp = document.createElement('div');
        temp.innerHTML = html;
        const newContent = temp.querySelector('.product-recommendations');
        if (!newContent) return;

        if (newContent.querySelector('.swiper-slide')) {
          targetNode.innerHTML = newContent.innerHTML;
          if (skel) skel.style.display = 'none';
          console.info('[PR] Updated');
        } else {
          if (skel) skel.style.display = 'none';
          const mainSection = document.querySelector('.product-recommendations');
          if (mainSection) mainSection.style.display = 'none';
          console.info('[PR] No products — hiding section');
          return;
        }

        setTimeout(() => {
          if (typeof initializeMuskPRODUCTRECOMMENDATION === 'function') {
            initializeMuskPRODUCTRECOMMENDATION();
            console.info('[PR] init re-run');
          }
        }, 150);
      } catch (err) {
        console.error('[PR] fetchRecommendations error:', err);
        var skeletonEl = targetNode ? targetNode.closest('[id^="shopify-section-"]') : null;
        var skel = skeletonEl ? skeletonEl.querySelector('.pr-skeleton') : null;
        if (skel) skel.style.display = 'none';
        var mainSectionErr = document.querySelector('.product-recommendations');
        if (mainSectionErr) mainSectionErr.style.display = 'none';
      }
    };

    const initObserver = () => {
      const section = getSection();
      if (!section) return;

      if ('IntersectionObserver' in window && !isEditor) {
        const observer = new IntersectionObserver(
          (entries, obs) => {
            const entry = entries[0];
            if (entry && entry.isIntersecting) {
              obs.unobserve(entry.target);
              fetchRecommendations(entry.target);
            }
          },
          { rootMargin: '0px 0px 200px 0px' },
        );
        observer.observe(section);
      } else {
        fetchRecommendations(section);
      }
    };

    const setupEditorListeners = () => {
      const safeReload = debounce(() => {
        const section = getSection();
        if (section) fetchRecommendations(section);
        else console.info('[PR] No section found — waiting...');
      }, 500);

      const events = [
        'shopify:section:load',
        'shopify:section:select',
        'shopify:block:select',
        'shopify:section:reorder',
        'shopify:section:deselect',
        'shopify:inspector:save',
      ];

      events.forEach((e) => {
        document.addEventListener(e, safeReload);
      });

      // Recheck every few seconds if section appears (for page switch in editor)
      if (isEditor) {
        setInterval(() => {
          const section = getSection();
          if (section && !section.dataset.initialized) {
            section.dataset.initialized = 'true';
            console.info('[PR] Section detected after save — reinit');
            initObserver();
          }
        }, 2000);
      }
    };

    const init = () => {
      const section = getSection();
      if (!section) {
        console.info('[PR] No product recommendations section found');
        if (isEditor) setupEditorListeners(); // ensure listeners still bind
        return;
      }
      initObserver();
      if (isEditor) setupEditorListeners();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
